/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Query_Keys } from "../../../lib/queryKeys";
import { mergeQueryKeys, getBaseQueryKey } from "../utils/queryKeyHelpers";

// The profiles list is refreshed too: saving or removing a user moves that profile's
// `assigned_users_count`, which is both shown on the list and what blocks deleting it.
const adminRefreshKeys = mergeQueryKeys(
  getBaseQueryKey(Query_Keys.admins),
  getBaseQueryKey(Query_Keys.admin_user_dropdown),
  getBaseQueryKey(Query_Keys.permission_profiles)
);

export const adminMutationKeyGroups = {
  create: adminRefreshKeys,
  update: adminRefreshKeys,
  delete: adminRefreshKeys,
  toggleStatus: [getBaseQueryKey(Query_Keys.admins)]
};
